<template>
  <!-- downloadConfirmation Modal -->
  <div
    class="modal fade"
    id="singledownloadConfirmationModal"
    tabindex="-1"
    aria-labelledby="downlaodConfirmationModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="downloadConfirmationModalLabel">
            Single Request Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <span v-if="selectedStatus == 'Stored'">
              Are you sure you want to request to download the selected
              information packages?
            </span>
            <span v-else>
              Package was not successfully stored. Unable to request for
              download.
            </span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="selectedStatus == 'Stored'"
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            v-if="selectedStatus == 'Stored'"
            type="button"
            class="btn btn-success"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="requestDownload"
          >
            Confirm
          </button>
          <button
            v-else
            type="button"
            class="btn btn-secondary"
            style="width: 100%"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDownloadStore } from "@/stores/download";
import { ref, watch } from "vue";

const downloadStore = useDownloadStore();
const selectedPackages = ref();
const selectedStatus = ref();
const props = defineProps({
  selectedId: { type: String },
  selectedStatus: { type: String },
});

watch(
  () => props.selectedId,
  (newId) => (selectedPackages.value = newId)
);

watch(
  () => props.selectedStatus,
  (newStatus) => (selectedStatus.value = newStatus)
);

const requestDownload = async () => {
  await downloadStore.requestPD(selectedPackages.value);
};
</script>

<style scoped>
li {
  padding-right: 10px;
  margin: auto;
  display: inline-block;
}
</style>
